import { memo, useEffect, useState } from 'react';
import { classNames } from '~/utils/classNames';

interface LoadingDotsProps {
  text: string;
  className?: string;
}

export const LoadingDots = memo(({ text, className }: LoadingDotsProps) => {
  const [dotCount, setDotCount] = useState(3);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prevDotCount) => (prevDotCount + 1) % 4);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={classNames('flex justify-center items-center h-full', className)}>
      <div className="relative">
        <span>{text}</span>
        <span className="absolute left-[calc(100%-12px)]">{'.'.repeat(dotCount)}</span>
        <span className="invisible">...</span>
      </div>
    </div>
  );
});
